export const getIsButtonEnabled = (deviceId, errors) => {
  if (!deviceId || Object.values(errors).some((e) => e)) return false;

  return true;
};
